var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef, useCallback, useState, } from "react";
import { Button } from "../Button";
import { Icon } from "../Icon";
// styles
import "./input.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-input",
    size: "medium",
    type: "text",
    helpText: "",
    label: "",
};
const VALIDATORS = {
    upperAndLower: (val) => {
        const containsUpper = /[A-Z]/.test(val);
        const containsLower = /[a-z]/.test(val);
        return containsUpper && containsLower;
    },
    atLeastANumber: (val) => {
        return /[0-9]/.test(val);
    },
    atLeastASymbol: (val) => {
        // This regular expression matches anything that isn't a letter or as digit
        return /[\W_]/.test(val);
    },
    minimumMaximumLength: (val) => {
        return val.length <= 20 && val.length > 7;
    },
};
export const getValidatorsPass = (str, validators) => Object.fromEntries(Object.keys(validators).map((validatorKey) => [validatorKey, VALIDATORS[validatorKey](str)]));
const Input = forwardRef((_a, ref) => {
    var { size, type, helpText, status, iconName, onIconClick, onChange, className, disabled, placeholder, label, id, style, validators, validatorResults, "data-testid": dataTestId, value } = _a, rest = __rest(_a, ["size", "type", "helpText", "status", "iconName", "onIconClick", "onChange", "className", "disabled", "placeholder", "label", "id", "style", "validators", "validatorResults", "data-testid", "value"]);
    const [inputType, setInputType] = useState(type || "text");
    const classList = classNames("tecma-input", `type-${type}`, {
        [`${size}`]: size,
        [`${status}`]: status,
        disabled,
    }, className);
    const inputClassList = classNames("input-container");
    const handleIconClick = useCallback((e) => {
        if (type === "password") {
            if (inputType === "password") {
                setInputType("text");
            }
            else {
                setInputType("password");
            }
        }
        if (onIconClick) {
            onIconClick(e);
        }
    }, [inputType, onIconClick, type]);
    const passwordIcon = inputType === "password" ? "eye-off" : "eye";
    const allValidatorsPass = validatorResults
        ? Object.values(validatorResults).every((val) => val)
        : null;
    const hasValue = Boolean(value && String(value).length);
    return (_jsxs("div", { className: classList, id: id, style: style, "data-testid": dataTestId, children: [label && _jsx("span", { className: "input-label", children: label }), _jsxs("div", { className: inputClassList, children: [_jsx("input", Object.assign({ placeholder: placeholder, onChange: onChange, type: inputType, "data-valid": allValidatorsPass, value: value, ref: ref, disabled: disabled }, rest)), iconName && _jsx(Icon, { iconName: iconName }), status === "error" && _jsx(Icon, { iconName: "exclamation-circle" }), type === "password" && (_jsx(Button, { className: "input-button", iconName: passwordIcon, onClick: handleIconClick, color: "transparent" }))] }), helpText && (_jsx("span", { className: status === "error" ? "help-text-errored" : "help-text", children: helpText })), validators && validatorResults && (_jsx("ul", { className: "validators", children: Object.entries(validators).map(([validatorKey, validatorLabel]) => (_jsxs("li", { className: classNames("validator", hasValue &&
                        validatorResults &&
                        (validatorResults[validatorKey] ? "validator-ok" : "validator-ko")), children: [(!hasValue || !validatorResults) && _jsx(Icon, { iconName: "check-circle", size: "small" }), hasValue &&
                            validatorResults &&
                            (validatorResults[validatorKey] ? (_jsx(Icon, { iconName: "check-circle", filled: true, size: "small" })) : (_jsx(Icon, { iconName: "x-circle", filled: true, size: "small" }))), _jsx("span", { className: "validator-label", children: validatorLabel })] }))) }))] }));
});
Input.defaultProps = defaultProps;
export default Input;
